import { render, staticRenderFns } from "./CompanyLogo.vue?vue&type=template&id=3c0849a8&scoped=true&"
import script from "./CompanyLogo.vue?vue&type=script&lang=js&"
export * from "./CompanyLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0849a8",
  null
  
)

export default component.exports